import React from 'react'
import { MessageBundle } from '@amzn/arb-tools'
import { t } from '@src/translationHelper'
import { IOperationsTabConfig, IOperationsTabMetrics } from '../../types'
import { fetchActiveIssueCount, fetchActionRequiredCount } from './issuesMetrics'
import StoreHealthView from './StoreHealthView'

/**
 * Issues tab metrics, aggregated across every store the logged-in user can access:
 *   - line 1 (primary):   total active (unresolved) issues
 *   - line 2 (secondary): "<n> Action Required" — items needing action across issues AND tasks
 */
async function fetchIssuesMetrics (storeIds: string[], bundle: MessageBundle): Promise<IOperationsTabMetrics> {
    const [activeIssues, actionRequired] = await Promise.all([
        fetchActiveIssueCount(storeIds),
        fetchActionRequiredCount(storeIds),
    ])
    return {
        primary: activeIssues,
        secondary: t(bundle, 'jsma-web-operations-actionRequired', { actionRequiredCount: actionRequired }),
        secondaryTone: actionRequired > 0 ? 'alert' : undefined,
    }
}

/** The Issues tab: active-issue / action-required counts, with the Store Health View as content. */
export const issuesTab: IOperationsTabConfig = {
    id: 'issues',
    labelStringId: 'jsma-web-operations-issuesTabLabel',
    fetchMetrics: fetchIssuesMetrics,
    renderContent: () => <StoreHealthView />,
    // Keep the content mounted across tab switches so the embedded iframe is not reloaded.
    keepMounted: true,
}
